module.exports = __webpack_public_path__ + "public/files/img/noor.ecad472b.jpg";